import React from 'react';
import { isNewUI } from '../../utils/handleProgress';
import SelfieOld from '../SelfieOld/SelfieOld';
import LiveSelfie from '../POSV_New_Ui/LiveSelfie/LiveSelfie';

const SelfiePage =()=>{
    return isNewUI() ? <LiveSelfie/> :<SelfieOld />
}

export default SelfiePage